// @flow
const account = 'https://meinereisen.test.meinschiff.com';
export default {
  trackingCode: 'qa', //'UA-6438006-17',
  cookieDomain: '.jakala.services',
  logoutURL: 'https://tuic-mrl.prelive.jakala.services/login',
  account,
  accountLogin: `${account}/signin`,
  accountRegister: `${account}/signin/registration`,
  excursionMultiSelectCacheKey: 'travelPartyState',
  iadvizeId: '6761',
};
